import { render, staticRenderFns } from "./UploadsPage.vue?vue&type=template&id=a6044fa2&scoped=true"
import script from "./UploadsPage.vue?vue&type=script&lang=js"
export * from "./UploadsPage.vue?vue&type=script&lang=js"
import style0 from "./UploadsPage.vue?vue&type=style&index=0&id=a6044fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6044fa2",
  null
  
)

export default component.exports